export const DEFAULT_FILES_LIMIT = 1;
export const DEFAULT_SIZE_LIMIT = 10; // мегабайты (МБ)
